import { render } from "./input-wysiwyg.vue?vue&type=template&id=4c53b459"
import script from "./input-wysiwyg.vue?vue&type=script&lang=js"
export * from "./input-wysiwyg.vue?vue&type=script&lang=js"

import "./input-wysiwyg.vue?vue&type=style&index=0&id=4c53b459&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__